// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RoleMgrOutlinedSvg from "@fishx/icons-svg/es/asn/RoleMgrOutlined";
import FishxIcon from '../components/FishxIcon';

var RoleMgrOutlined = function RoleMgrOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RoleMgrOutlinedSvg
  }));
};

RoleMgrOutlined.displayName = 'RoleMgrOutlined';
export default React.forwardRef(RoleMgrOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RoleMgrOutlined.js
// module id = 4042
// module chunks = 0